import { useCallback } from 'react';
import { postRepairedPickUpReserveApi } from '@/api/bodyAndPaint';
import { RepairedPickUpReserveParams } from '@/types/api/bodyAndPaint';

interface PostRepairedPickUpReserveHookProps {
  info: RepairedPickUpReserveParams;
}
export const usePostRepairedPickUpReserve = ({
  info,
}: PostRepairedPickUpReserveHookProps) => {
  const postRequest = useCallback(async () => {
    try {
      if (
        info &&
        new Date(info.no1_pref_date_time) instanceof Date &&
        !isNaN(new Date(info.no1_pref_date_time).getTime())
      ) {
        const fetch = await postRepairedPickUpReserveApi(info);
        return fetch;
      } else {
        throw 'invalid params';
      }
    } catch (error) {
      console.error(error);
    }
  }, [info]);

  return { postRequest };
};
